(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-image-with-text"] && !Shopify.designMode) return;
  try {
    
    const ele = document.getElementsByClassName('custom-iwt-container')[0]

   	window.addEventListener('scroll', playIWTAnimation)

    function playIWTAnimation() {
        if(document.getElementsByClassName('custom-iwt-container')[0].getBoundingClientRect().top - window.innerHeight < -100) {
            document.getElementsByClassName('custom-iwt-text-wrapper')[0].classList.add('custom-IWTcontainer-animation')
            document.getElementsByClassName('custom-iwt-text')[0].classList.add('custom-IWTtext-animation')
            document.getElementsByClassName('custom-iwt-header')[0].classList.add('custom-IWTtext-animation')
            document.getElementsByClassName('custom-iwt-image-wrapper')[0].classList.add('custom-IWTimage-animation')
        }
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-shop"]) return;
  try {
    
    document.addEventListener("keyup", (e)=> e.key === "Escape" ? closeImage() : '')

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-text-with-image"] && !Shopify.designMode) return;
  try {
    
window.addEventListener('scroll', playAnimation)

function playAnimation() {
  if(document.getElementsByClassName('custom-section-header')[0].getBoundingClientRect().top - window.innerHeight < -100) document.getElementsByClassName('custom-section-header')[0].classList.add('custom-text-animation');
  if(document.getElementsByClassName('custom-section-text')[0].getBoundingClientRect().top - window.innerHeight < -100) document.getElementsByClassName('custom-section-text')[0].classList.add('custom-text-animation');
  if(document.getElementsByClassName('custom-section-img-container')[0].getBoundingClientRect().top - window.innerHeight < -100) Array.from(document.getElementsByClassName('custom-section-img')).forEach(e => e.classList.add('custom-rolling-animation'));
}

  } catch(e) { console.error(e); }
})();
})();
